'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Route, Switch } from 'react-router-dom'; // Only import and use 'containers' for your route handlers

import Application from './containers/Application';
import Home from './containers/Home';
export default /*#__PURE__*/_jsx(Switch, {
  children: /*#__PURE__*/_jsx(Route, {
    path: "/",
    children: /*#__PURE__*/_jsx(Application, {
      children: /*#__PURE__*/_jsx(Route, {
        exact: true,
        path: "/",
        component: Home
      })
    })
  })
});